var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8754 10.5C21.4233 7.65093 19.6428 3.79149 14.9614 3.03969C13.8627 2.86324 12.7735 3.29163 11.8958 3.99733L11.2995 4.47962C11.7282 4.84644 12 5.39148 12 6C12 7.10457 11.1046 8 10 8C9.24042 8 8.57974 7.57656 8.24114 6.95286L3.85486 10.5H21.8754Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V12H22ZM16.5 18C17.8807 18 19 16.8807 19 15.5C19 14.1193 17.8807 13 16.5 13C15.1193 13 14 14.1193 14 15.5C14 16.8807 15.1193 18 16.5 18ZM8 19C9.10457 19 10 18.1046 10 17C10 15.8954 9.10457 15 8 15C6.89543 15 6 15.8954 6 17C6 18.1046 6.89543 19 8 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/cheese.37a5bf30395b18623433ec41e06b9d6e.svg";
export { ForwardRef as ReactComponent };